import {
  Modal,
  Box,
  Divider,
  useTheme,
  useMediaQuery,
} from '@ltvco/refresh-lib/theme';
import {
  useAccount,
  useSession,
  invalidateSession,
  closeSnackbar,
} from '@ltvco/refresh-lib/v1';
import { useNavigate } from 'react-router-dom';

import { constants } from 'appConstants';
import { goToLogin } from 'utils/goToLogin';

import { LogoutButton } from './LogoutButton';
import { NavigationSection } from './NavigationSection';
import { getModalStyles, getContainerBoxStyles } from './styles';
import { UpgradeSection } from './UpgradeSection';
import { UserInfoSection } from './UserInfoSection';

type ProfileModalProps = {
  open: boolean;
  onClose: () => void;
  onUpgradePlanClick?: () => void;
  onHelpClick?: () => void;
  onFeedbackClick?: () => void;
  onLogout?: () => void;
};

export const ProfileModal = ({
  open,
  onClose,
  onUpgradePlanClick,
  onHelpClick,
  onFeedbackClick,
  onLogout,
}: ProfileModalProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const {
    session: { isAuthenticated },
  } = useSession();
  const { data: account } = useAccount(isAuthenticated);
  const {
    links: { FaqLink },
  } = constants;

  const handleAccountClick = () => {
    onClose();
    navigate('/dashboard/billing');
  };

  const handleHelpClick = () => {
    onClose();
    onHelpClick?.();
  };

  const handleFeedbackClick = () => {
    onClose();
    onFeedbackClick?.();
  };

  const handleUpgradeClick = () => {
    onClose();
    onUpgradePlanClick?.();
  };

  const handleLearnMoreClick = () => {
    window.open(FaqLink, '_blank');
  };

  const handleLogoutClick = async () => {
    onClose();
    if (onLogout) {
      onLogout();
    } else {
      await invalidateSession();
      closeSnackbar();
      goToLogin('https://www.beenverified.com');
    }
  };

  return (
    <Modal open={open} onClose={onClose} sx={getModalStyles(isMobile)}>
      <Box sx={getContainerBoxStyles(theme)}>
        <UserInfoSection account={account} />

        <Divider sx={{ borderColor: theme.palette.divider }} />

        <NavigationSection
          onAccountClick={handleAccountClick}
          onHelpClick={handleHelpClick}
          onFeedbackClick={handleFeedbackClick}
        />

        <Divider sx={{ borderColor: theme.palette.divider }} />

        <UpgradeSection
          onUpgradeClick={handleUpgradeClick}
          onLearnMoreClick={handleLearnMoreClick}
        />

        <Divider sx={{ borderColor: theme.palette.divider }} />

        <LogoutButton onLogout={handleLogoutClick} />
      </Box>
    </Modal>
  );
};
